import $ from "jquery";

const $shelfLeftTrigger = $(".js-shelf-left-trigger");
const $shelfRightTrigger = $(".js-shelf-right-trigger");
const $sections = $(".sections");

const $html = $("html");
const $body = $("body");
const $shelves = $(".shelves");
const $closeShelves = $(".close-shelves");

$shelfLeftTrigger.on("click", function() {
  $shelves.addClass("active");
  $body.removeClass("right-shelf-active");
  $body.addClass("left-shelf-active");
  $html.addClass("is-clipped");
  $sections.addClass("nav-open");
});

$shelfRightTrigger.on("click", function() {
  $shelfRightTrigger.addClass("active");
  $shelves.addClass("active");
  $body.removeClass("left-shelf-active");
  $body.addClass("right-shelf-active");
  $html.addClass("is-clipped");
  $sections.addClass("nav-open");
});

$closeShelves.on("click", function() {
  $shelfRightTrigger.removeClass("active");
  $shelves.removeClass("active");
  $body.removeClass("left-shelf-active");
  $body.removeClass("right-shelf-active");
  $html.removeClass("is-clipped");
  $sections.removeClass("nav-open");
});
